/* eslint-disable @typescript-eslint/no-explicit-any */
export abstract class IEnvironment {
  static appTitle: null | string;
  static production: null | boolean;
  static domain: null | string;
  static urlAPI: null | string ;
  static urlAPIStable: null | string;
  static locale: null | string;
  static currencyCode: null | string;
  static defaultRoleId: null | number;
  static ui: null | string;
  static orgId: null | string;
  static gtmId: null | string;
  static enableAnalytics: null | boolean;
  static enableDevToolsRedux: null | boolean;
  static enableComponentView: null | boolean;
  static homeDirectory: null | string;
  static stableAPIKey: null | string;
  static pusher: null | any;
  static environment: null | string;
  static eProtect: null | any;
  static debug: boolean;
  static smartlook: string;
}
